/**
 * @desc 显示分页
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.monthlyReport.pages.Params, options?: any) {
  return updateResponse(
    http(URL + `/monthlyReport/pages`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
